import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment as ENV } from 'environments/environment';

// import { AdminAuthService } from './admin/admin-auth.service';

@Injectable()
export class InterceptorRespService implements HttpInterceptor {
  token: string;
  state: string;
  route: string;
  private sessionExpiredShown = false;
  constructor() { }

  private handleAuthError(err: HttpErrorResponse) {
    if (err.status === 401 && !this.sessionExpiredShown) {
      this.sessionExpiredShown = true;
      alert('Session has expired. The page will now refresh.');
      window.location.reload();
    }
    return throwError(err);
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let clonedRequest = req;

    // Check if the request URL includes "getUserVerified"
    try {
      // if (req.url.includes("getUserVerified") && ENV.enableEncoding) {
      if (ENV.enableEncoding) {
        // Encode payload to Base64 for outgoing requests
        if (req.body) {
          // const encodedBody = btoa(JSON.stringify(req.body));

          // // Clone the request with the encoded body
          // clonedRequest = req.clone({
          //   body: {data:encodedBody}
          // });

          // Convert the JSON string to a Uint8Array
          const buffer = new TextEncoder().encode(JSON.stringify(req.body));

          // Convert the Uint8Array to a Base64 string
          let stringFromBuffer = '';
          for (let i = 0; i < buffer.length; i++) {
            stringFromBuffer += String.fromCharCode(buffer[i]);
          }

          const base64String = btoa(stringFromBuffer);

          // Resulting Base64 string
          console.log(base64String);
          clonedRequest = req.clone({
            body: { data: base64String }
          });

        }

        return next.handle(clonedRequest).pipe(
          map(event => {
            // Decode the response if it's an HttpResponse
            if (event instanceof HttpResponse) {
              // Decode Base64 string to binary data (Uint8Array)
              const base64String = event.body.data; // Your Base64 string
              const binaryString = atob(base64String); // Decode Base64 to binary
              let byteArray = new Uint8Array(binaryString.split('').map(char => char.charCodeAt(0)));

              // Use TextDecoder to decode the Uint8Array into a string
              const textDecoder = new TextDecoder('utf-8'); // Specify encoding (default is UTF-8)
              const decodedBody = textDecoder.decode(byteArray);

              // Parse the JSON (since your backend sent encoded JSON)
              const parsedBody = JSON.parse(decodedBody);

              console.log("Decrypted response from:", req.url, parsedBody);
              return event.clone({ body: parsedBody });
            }

            return event; // Return the event unchanged if it's not an HttpResponse
          }),
          catchError(err => this.handleAuthError(err))
        );

      } else {
        // Handle requests that do not include "getUserVerified"
        return next.handle(req).pipe(
          map(event => {
            return event; // Return the event unchanged
          }),
          catchError(err => this.handleAuthError(err))
        );
      }
    } catch (err) {
      console.log(err)
    }

  }


}